import consumer from "./consumer";

export const AppearanceChannel = consumer.subscriptions.create(
  "AppearanceChannel",
  {
    initialized() {
      this.update = this.update.bind(this);
    },

    connected() {
      this.install();
      this.update();
      // console.log("Connected to AppearanceChannel");
    },

    disconnected() {
      this.uninstall();
      // console.log("Disconnected to AppearanceChannel");
    },

    rejected() {
      this.uninstall();
    },

    update() {
      this.documentIsActive ? this.appear() : this.away();
    },

    appear() {
      this.perform("appear", { appearing_on: this.appearingOn });
    },

    away() {
      this.perform("away");
    },

    install() {
      window.addEventListener("focus", this.update);
      window.addEventListener("blur", this.update);
      document.addEventListener("DOMContentLoaded", this.update);
      document.addEventListener("visibilitychange", this.update);
    },

    uninstall() {
      window.removeEventListener("focus", this.update);
      window.removeEventListener("blur", this.update);
      document.removeEventListener("DOMContentLoaded", this.update);
      document.removeEventListener("visibilitychange", this.update);
    },

    received(data: { user_id: string; online: boolean }) {
      const { user_id, online } = data;
      // console.log(`User ${user_id} is now ${online ? "online" : "offline"}`);

      const userStatus = document.querySelectorAll(
        `[data-user-id="${user_id}"]`,
      );
      if (userStatus) {
        userStatus.forEach((x) =>
          x.classList.toggle("fui-user-status--online", online),
        );
      }
    },

    get documentIsActive() {
      return document.visibilityState === "visible" && document.hasFocus();
    },

    get appearingOn() {
      const element = document.querySelector("[data-appearing-on]");
      return element ? element.getAttribute("data-appearing-on") : null;
    },
  },
);
